
export const getPdfToTextConfig = async (url, token, pdfFile) => {
  try {
      const result = await fetch(url + `/ollama-mcp/pdf-to-text-config`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        },
        // body: formData,
      });

      if (!result.ok) {
        throw new Error("error occured");
      }

      const resData = await result.json();
      console.log(result, resData);
      
      return resData;
  } catch(err) {
    console.log(err);
    throw err;
  }
};

export const ollamaMcpPdfToText = async (
  url, 
  token, 
  pdfFile,
  customerId,
  priceId,
  userId,
  originalFileName,
) => {
  try {

      const formData = new FormData();
      formData.append('files', pdfFile);

      formData.append('customerId', customerId);
      formData.append('priceId', priceId);
      formData.append('userId', userId);
      formData.append('originalFileName', originalFileName);

      const result = await fetch(url + `/ollama-mcp/pdf-to-text`, {
        method: 'POST',
        headers: {
          // 'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        },
        body: formData,
      });

      if (!result.ok) {
        throw new Error("error occured");
      }

      const resData = await result.json();
      console.log(result, resData);
      
      return resData;
  } catch(err) {
    console.log(err);
    throw err;
  }
};